import { SearchResultType } from "../../list";
import { extractDimsAndMeasures } from "@src/util/intelligence-search/get-metric-type-from-filters";
import { createRendererMapping } from "@src/util/intelligence-search/asset-renderer";
import { getMemberColor } from "@src/util/intelligence-search/get-member-info";
import { SmlJsonQueryFilter } from "@src/types/intelligence-search";
import React, { useState } from "react";
import { FieldTypeConfig, PivotTable, StyleConfig } from "@src/components/pivot-table";
import { convertDataTypeToFieldDataType } from "@src/components/pivot-table/pivot-table";

const RawDataInsight: React.FC<{
    isLoading: boolean;
    loadResult: SearchResultType | undefined;
    filters: SmlJsonQueryFilter[];
}> = ({ isLoading, loadResult, filters }) => {
    const { dimensions, measures } = extractDimsAndMeasures(filters);
    const dimensionColors = getMemberColor("dimension");
    const measureColors = getMemberColor("metric");

    const rendererMapping = createRendererMapping(loadResult?.meta?.schema || [], loadResult?.ref_assets || []);

    const fieldTypes: FieldTypeConfig = filters
        .filter((f) => !f.operator)
        .reduce((acc, currItem) => {
            if (!currItem.meta) return acc;
            acc[currItem.meta.name] = convertDataTypeToFieldDataType(currItem.meta.data_type);
            return acc;
        }, {} as FieldTypeConfig);
    const customStyles: StyleConfig = {
        headerStyle: (fieldName: string) => {
            if (dimensions.includes(fieldName)) {
                return { backgroundColor: dimensionColors.backgroundColorWithOpacitySecondary };
            }
            return { backgroundColor: measureColors.backgroundColorWithOpacitySecondary };
        },
        cellStyle: {
            borderRight: "1px solid #e9ecef",
        },
    };

    const dataSource = React.useMemo(() => {
        return loadResult?.data ?? [];
    }, [loadResult]);
    return (
        <div className="my-10">
            <div
                style={{
                    height: dataSource?.length > 100 ? 700 : 500,
                }}
                className="border border-gray-300 rounded-md"
            >
                <PivotTable<Record<string, any>>
                    data={dataSource}
                    totalRows={loadResult?.meta?.total_rows ?? 0}
                    rendererMapping={rendererMapping}
                    fieldConfig={{
                        dimensions: dimensions,
                        measures: measures,
                    }}
                    customStyle={customStyles}
                    fieldTypes={fieldTypes}
                    loading={isLoading}
                    height="100%"
                />
            </div>
        </div>
    );
};

export const RawDataInsightMemo = React.memo(RawDataInsight);
